import axios, { AxiosError } from "axios";
import { ReactNode, useEffect, useState } from "react";
import TooltipInfo from "../../../components/TooltipInfo";
import { ProgressSpinner } from 'primereact/progressspinner';

type PropsFormUser = {
  currentStep: number;
  setCurrentStep: (value: number) => void;
  registerId: string;
  token: string;
  prices: any[];
  dataUser: any;
  paymentSelected: (value: string) => void;
  tuition: number;
  discount: any;
  allianceDiscount?: any;
  totalDiscountPercentage?: number;
  tuitionExempted: boolean;
  variantApplication: boolean;
};

export const SelectPayment = (props: PropsFormUser) => {
  const [cardSelected1, setCardSelected1] = useState(false);
  const [cardSelected2, setCardSelected2] = useState(false);
  const [cardSelected3, setCardSelected3] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [count, setCount] = useState(0);
  const [firstDueDate, setFirstDueDate] = useState(null);
  const [activeCount, setActiveCount] = useState(false);
  const [listPaymentMethods, setListPaymentMethods] = useState([]);
  const [listDueDates, setListDueDates] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [nQuotes, setNQuotes] = useState(0);
  const [paymentMethodIdSelected, setPaymentMethodIdSelected] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [quotesSelected, setQuotesSelected] = useState(0);
  const [totalMonth, setTotalMonth] = useState(0);
  const [isdecimal, setIsDecimal] = useState(false);
  const [payments, setPayments] = useState<number[]>([]);
  const [loader, setLoader] = useState(false);

  const fetchData = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/registers/${props.registerId}/payment_methods`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_user_latam")}`,
          },
        }
      )
      .then((response) => {
        setListPaymentMethods(response.data);
      });

    await axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/registers/${props.registerId}/generation_due_dates`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_user_latam")}`,
          },
        }
      )
      .then((response) => {
        setListDueDates(response.data);
      });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (count != 0 && totalMonth % count != 0) {
      setIsDecimal(true)
      const numInstallments = Number(count)
      const calculatedInstallments = calculateInstallments(totalMonth, numInstallments);
      setPayments(calculatedInstallments);

    } else {
      setIsDecimal(false)
      setPayments([]);
    }
  }, [count, totalMonth]);


  function calculateInstallments(total: number, numInstallments: number): number[] {

    const basePayment = Math.floor(total / numInstallments);
    const remainder = total % numInstallments;

    const payments: number[] = new Array(numInstallments).fill(basePayment);
    if (remainder !== 0) {
      payments[0] += remainder;
    }

    return payments;
  }

  const prevStep = () => {
    props.setCurrentStep(props.currentStep - 1);
  };

  const nextStep = () => {
    props.setCurrentStep(props.currentStep + 1);
  };

  const handleNextStep = async () => {
    setLoader(true);
    setDisabledBtn(true);
    await axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/purchases/store`,
        {
          register_id: props.registerId,
          payment_method_id: paymentMethodIdSelected,
          quotes: quotesSelected,
          first_due_date: firstDueDate,
          total: totalPayment,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token_user_latam")}`,
          },
        }
      )
      .then((response) => {
        axios
          .post(
            `${process.env.REACT_APP_API_BACKEND
            }/registers/${localStorage.getItem("register_id")}/step`,
            {
              // step: cardSelected2
              //   ? props.currentStep + 2
              //   : props.currentStep + 1
              step: props.currentStep + 1,
            },
            {
              headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: `Bearer ${localStorage.getItem(
                  "token_user_latam"
                )}`,
              },
            }
          )
          .then((response: any) => {
            nextStep();
          })
          .catch((error: AxiosError) => console.log("Error Aval =>", error));
      })
      .catch((error: AxiosError) => console.error(error))
  };

  function getDiscountFromProps() {
    if (props.totalDiscountPercentage !== undefined) return props.totalDiscountPercentage;
    return props.discount ? props.discount.percentage : 0;
  }

  function renderDiscountInfo() {
    const total = getDiscountFromProps();
    if (total === 0) return null;
    if (props.allianceDiscount) {
      return (
        <div className="mb-4 space-y-1">
          {props.discount && (
            <p className="text-sm text-gray-600">
              Descuento campaña:{" "}
              <span className="font-semibold text-green-600">{props.discount.percentage}%</span>
              {props.discount.description ? ` (${props.discount.description})` : ""}
            </p>
          )}
          <p className="text-sm text-gray-600">
            Descuento alianza:{" "}
            <span className="font-semibold text-green-600">{props.allianceDiscount.percentage}%</span>
            {props.allianceDiscount.description ? ` (${props.allianceDiscount.description})` : ""}
          </p>
          <p className="text-sm font-semibold text-green-600">
            Descuento total: {total}%
          </p>
        </div>
      );
    }
    return (
      <p className="text-sm font-semibold text-green-600 mb-4">
        Descuento: {total}%
      </p>
    );
  }

  function getTuitionFromProps() {
    return props.tuitionExempted ? 0 : props.tuition;
  }

  const isPro = props.dataUser?.enrollment_type === 0;

  const getReferenceValue = (element: any) => {
    if (isPro) {
      return props.variantApplication
        ? props.dataUser.price.pro_variant_value
        : props.dataUser.price.pro_value;
    }
    return props.variantApplication
      ? element.pivot.variant_reference_value
      : element.pivot.reference_value;
  };

  const getQuotesValue = (element: any) => {
    if (isPro) {
      const proVal = props.variantApplication
        ? props.dataUser.price.pro_variant_value
        : props.dataUser.price.pro_value;
      return element.pivot.quotes ? Math.round(proVal / element.pivot.quotes) : null;
    }
    return props.variantApplication
      ? element.pivot.variant_quotes_value
      : element.pivot.quotes_value;
  };

  const selectCard = (key: string, element: any) => {
    setCardSelected2(false);


    switch (key) {
      case "1":
        setTotalValue(
          Math.round((
            getReferenceValue(element) -
            (getDiscountFromProps() / 100) * getReferenceValue(element) +
            getTuitionFromProps()
            + Number.EPSILON) * 100) / 100
        );

        setTotalMonth(
          Math.round((
            getReferenceValue(element) -
            (getDiscountFromProps() / 100) * getReferenceValue(element)
            + Number.EPSILON) * 100) / 100
        );
        setNQuotes(element.pivot.quotes);
        setPaymentMethodIdSelected(Number(key));

        setTotalPayment(getTuitionFromProps() +
          (getReferenceValue(element) -
            (getDiscountFromProps() / 100) * getReferenceValue(element)));

        // localStorage.setItem('paymentMethod', 'Pago en cuotas');
        setActiveCount(true);
        setCardSelected1(true);
        setCardSelected2(false);
        setCardSelected3(false);
        setDiscount(getDiscountFromProps);
        break;
      case "2":
        setTotalValue(
          getReferenceValue(element) -
          (getDiscountFromProps() / 100) * getReferenceValue(element)
        );
        // localStorage.setItem('paymentMethod', 'Pago anticipado');
        setPaymentMethodIdSelected(Number(key));
        setTotalPayment(
          getTuitionFromProps() +
          (getReferenceValue(element) -
            (getDiscountFromProps() / 100) * getReferenceValue(element))
        );
        setQuotesSelected(0);
        setDiscount(getDiscountFromProps());
        setCardSelected1(false);
        setCardSelected2(true);
        setCardSelected3(false);
        setDisabledBtn(false);
        setActiveCount(false);
        break;
      case "3":
        setDiscount(getDiscountFromProps());
        localStorage.setItem("paymentMethod", "Pago en ISA");
        setPaymentMethodIdSelected(Number(key));
        setTotalPayment(getTuitionFromProps());
        setCardSelected1(false);
        setCardSelected2(false);
        setCardSelected3(true);
        setDisabledBtn(false);
        setActiveCount(false);
        setQuotesSelected(0);
        break;
    }
  };

  const formatPrice = (value: number) => {
    return new Intl.NumberFormat("es-ES", {}).format(Math.round(value));
  };

  return (
    <form method="post" className="w-full max-w-6xl mx-auto px-4">
      <div className="mb-8">
        <h2 className="text-xl text-center md:text-2xl font-semibold text-gray-900 mb-2">
          Selecciona tu forma de pago
        </h2>
        <p className="text-gray-600 text-sm text-center">
          Elige la opción que mejor se adapte a tus necesidades
        </p>
      </div>
      <div className="flex flex-col lg:flex-row gap-6 mb-6">
        <div className="flex flex-wrap justify-center gap-4 lg:flex-1">
          {listPaymentMethods.map((element: any, index) => {
            switch (element.description) {
              case "Pago Cuota":
                return (
                  <div
                    key={index}
                    className={`w-full sm:w-96 flex-shrink-0 bg-white border-2 rounded-lg p-6 cursor-pointer transition-all ${
                      cardSelected1 ? 'border-sky-600 shadow-sm' : 'border-gray-300 hover:border-gray-400'
                    }`}
                    onClick={() => selectCard("1", element)}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900 text-lg">
                        Cuotas mensuales
                      </h3>
                      <input
                        type="radio"
                        name="payment-method"
                        checked={cardSelected1}
                        onChange={() => selectCard("1", element)}
                        className="w-5 h-5 text-sky-600 focus:ring-sky-600"
                      />
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                      Paga en hasta {element.pivot.quotes} cuotas mensuales con
                      diferentes medios de pago en la fecha que más te convenga
                    </p>
                    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">Matrícula</span>
                        <span className="font-semibold text-gray-900">${formatPrice(getTuitionFromProps())}</span>
                      </div>
                      <div className="border-t border-gray-200 pt-2">
                        {isdecimal == true ?
                          <>
                            <div className="text-center py-2">
                              <p className="text-sm text-gray-600 mb-1">1 cuota de</p>
                              <p className="text-2xl font-bold text-sky-600">
                                ${formatPrice(payments[0])} {props.dataUser.price.currency.code}
                              </p>
                              <p className="text-sm text-gray-600 my-2">y</p>
                              <p className="text-sm text-gray-600 mb-1">{payments.length - 1} cuotas de</p>
                              <p className="text-2xl font-bold text-sky-600">
                                ${formatPrice(payments[1])} {props.dataUser.price.currency.code}
                              </p>
                            </div>
                            <TooltipInfo textInfo={'Importante: La primera cuota será ligeramente diferente al resto debido al redondeo necesario para ajustar los pagos totales a cantidades enteras.'}></TooltipInfo>
                          </>
                          :
                          <div className="text-center py-2">
                            <p className="text-sm text-gray-600 mb-1">{count > 0 ? count : element.pivot.quotes} cuotas de</p>
                            <p className="text-2xl font-bold text-sky-600">
                              ${count > 0 ? formatPrice(totalMonth / count) :
                                formatPrice(
                                  Math.round((
                                getReferenceValue(element) -
                                (getDiscountFromProps() / 100) * getReferenceValue(element)
                                + Number.EPSILON) * 100) / 100 / element.pivot.quotes
                                )} {props.dataUser.price.currency.code}
                            </p>
                          </div>
                        }
                      </div>
                    </div>

                    {getDiscountFromProps() != 0 &&
                      <div className="mb-4">
                        <p className="text-sm text-gray-600">
                          Valor Referencia:{" "}
                          <span className="line-through">
                            ${formatPrice(getReferenceValue(element))} {props.dataUser.price.currency.code}
                          </span>
                        </p>
                        {renderDiscountInfo()}
                      </div>
                    }

                    <div className="border-t border-gray-200 pt-4">
                      <div className="flex justify-between items-center mb-3">
                        <span className="font-semibold text-gray-900">Total a pagar</span>
                        <span className="text-xl font-bold text-sky-600">
                          ${formatPrice(
                            getReferenceValue(element) -
                            (getDiscountFromProps() / 100) *
                            getReferenceValue(element) +
                            getTuitionFromProps()
                          )} {element.pivot.currency}
                        </span>
                      </div>
                      <p className="text-xs text-gray-500">
                        <strong>Importante:</strong> Para asegurar tu matrícula deberás realizar el pago de la primera cuota <strong>hoy</strong>.
                      </p>
                    </div>
                  </div>
                );
              case "Anticipado":
                return (
                  <div
                    key={index}
                    className={`w-full sm:w-96 flex-shrink-0 bg-white border-2 rounded-lg p-6 cursor-pointer transition-all ${
                      cardSelected2 ? 'border-sky-600 shadow-sm' : 'border-gray-300 hover:border-gray-400'
                    }`}
                    onClick={() => selectCard("2", element)}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900 text-lg">
                        Pago anticipado
                      </h3>
                      <input
                        type="radio"
                        name="payment-method"
                        checked={cardSelected2}
                        onChange={() => selectCard("2", element)}
                        className="w-5 h-5 text-sky-600 focus:ring-sky-600"
                      />
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                      Paga con tarjeta de crédito, débito o prepago de forma segura
                    </p>

                    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">Matrícula</span>
                        <span className="font-semibold text-gray-900">
                          ${formatPrice(getTuitionFromProps())} {props.dataUser.price.currency.code}
                        </span>
                      </div>
                      <div className="border-t border-gray-200 pt-2">
                        <div className="text-center py-2">
                          <p className="text-sm text-gray-600 mb-1">Monto del programa</p>
                          <p className="text-2xl font-bold text-sky-600">
                            ${formatPrice(
                              getReferenceValue(element) -
                              (getDiscountFromProps() / 100) *
                              getReferenceValue(element)
                            )} {props.dataUser.price.currency.code}
                          </p>
                        </div>
                      </div>
                    </div>

                    {getDiscountFromProps() !== 0 &&
                      <div className="mb-4">
                        <p className="text-sm text-gray-600">
                          Valor Referencia:{" "}
                          <span className="line-through">
                            ${formatPrice(getReferenceValue(element))} {props.dataUser.price.currency.code}
                          </span>
                        </p>
                        {renderDiscountInfo()}
                      </div>
                    }

                    <div className="border-t border-gray-200 pt-4">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-gray-900">Total a pagar</span>
                        <span className="text-xl font-bold text-sky-600">
                          ${formatPrice(
                            getTuitionFromProps() +
                            (getReferenceValue(element) -
                              (getDiscountFromProps() / 100) *
                              getReferenceValue(element))
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              case "ISA":
                return (
                  <div
                    key={index}
                    className={`w-full sm:w-96 flex-shrink-0 bg-white border-2 rounded-lg p-6 cursor-pointer transition-all ${
                      cardSelected3 ? 'border-sky-600 shadow-sm' : 'border-gray-300 hover:border-gray-400'
                    }`}
                    onClick={() => selectCard("3", element)}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900 text-lg">
                        Acuerdo de ingresos compartidos (ISA)
                      </h3>
                      <input
                        type="radio"
                        name="payment-method"
                        checked={cardSelected3}
                        onChange={() => selectCard("3", element)}
                        className="w-5 h-5 text-sky-600 focus:ring-sky-600"
                      />
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                      Modelo de financiamiento donde solo comienzas a pagar una
                      vez consigues trabajo, sin costo inicial
                    </p>

                    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm text-gray-600">Matrícula</span>
                        <span className="font-semibold text-gray-900">${formatPrice(getTuitionFromProps())}</span>
                      </div>
                      <div className="border-t border-gray-200 pt-2">
                        <div className="text-center py-2">
                          <p className="text-sm text-gray-600 mb-1">Pagas</p>
                          <p className="text-2xl font-bold text-sky-600">
                            15% de tus ingresos
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="border-t border-gray-200 pt-4">
                      <div className="flex justify-between items-center">
                        <span className="font-semibold text-gray-900">Máximo a pagar</span>
                        <span className="text-xl font-bold text-sky-600">
                          $3.500.000
                        </span>
                      </div>
                    </div>
                  </div>
                );
              default:
                return <></>;
            }
          })}
        </div>

        {activeCount && (
          <div className="w-full sm:w-96 flex-shrink-0 bg-white border border-gray-300 rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-6">Configura tus cuotas</h3>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">
                  Número de cuotas
                </label>
                <select
                  className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
                  onChange={(evt: any) => {
                    setCount(evt.target.value);
                    if (cardSelected1) {
                      setQuotesSelected(evt.target.value);
                    }
                    if (
                      evt.target.value !== null &&
                      evt.target.value > 0 &&
                      firstDueDate !== "" &&
                      firstDueDate !== null
                    ) {
                      setDisabledBtn(false);
                    } else {
                      setDisabledBtn(true);
                    }
                  }}
                >
                  <option value={""}>Selecciona el número de cuotas</option>
                  {(() => {
                    let items: ReactNode[] = [];
                    for (let i = 1; i <= nQuotes; i++) {
                      items.push(
                        <option key={i} value={i}>
                          {i} {i === 1 ? 'cuota' : 'cuotas'}
                        </option>
                      );
                    }
                    return items;
                  })()}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-900 mb-2">
                  Fecha de facturación
                </label>
                <select
                  onChange={(evt: any) => {
                    setFirstDueDate(evt.target.value);
                    if (
                      count !== null &&
                      count > 0 &&
                      evt.target.value !== "" &&
                      evt.target.value !== null
                    ) {
                      setDisabledBtn(false);
                    } else {
                      setDisabledBtn(true);
                    }
                  }}
                  className="w-full border-2 border-gray-300 rounded-lg p-3 bg-white text-gray-900 focus:border-sky-600 focus:outline-none transition-colors"
                >
                  <option value={""}>Selecciona la fecha de pago</option>
                  {listDueDates.map((dd: string, idx: number) => (
                    <option key={idx} value={dd}>{dd.split("-").reverse().join("/")}</option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-2">
                  Selecciona el día en que deseas realizar el pago de la <strong>segunda cuota</strong>. Las siguientes cuotas se programarán en los meses posteriores, siempre en esa misma fecha.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="flex justify-between items-center pt-6 border-t border-gray-300">
        <button
          className="btn-prev"
          type="button"
          onClick={() => prevStep()}
        >
          Atrás
        </button>
        <button
          className={`btn ${disabledBtn ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={disabledBtn || loader}
          type="button"
          onClick={handleNextStep}
        >
          {loader ?
            <ProgressSpinner
              style={{ width: '20px', height: '20px' }}
              strokeWidth="6"
              fill="#ffffff"
              animationDuration="1.5s"
            /> : "Continuar"}
        </button>
      </div>
    </form>
  );
};
